// extracted by mini-css-extract-plugin
export default {"bar":"__KwTb","tile":"dctVNJ","value":"CeuGM2","label":"N7ieLC","total":"Y20RM_","up":"iV9rnl","down":"wjs9R_","unknown":"vaVfYx","inactive":"KxzzPk"};